import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableFijo from "../useTableFijo";

const TablaDeudaMinas = (props) => {
  let op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [deuda, setDeuda] = useState();
  const [interes, setInteres] = useState();
  const [recargo, setRecargo] = useState();
  const [multa, setMulta] = useState();
  const [totDeuda, setTotDeuda] = useState();

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "1",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-alt">
          {" "}
          AÑO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          MES
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          CONCEPTO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-bill">
          {" "}
          MONTO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i
          style={{ textAlign: "center" }}
          className="fas fa-money-bill-wave-alt"
        >
          {" "}
          INTERES MORA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-check">
          {" "}
          RECARGOS{" "}
        </i>
      ),
      textAlign: "center",
    },
  ];

  let heightTabla = 280;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, heightTabla);

  const imprimirDeudaGeneral = () => {
    const condicion =
      "(tipodeuda = 1 or tipodeuda=11 or tipodeuda=111) and D.status = 0";
    const fecha = fechaSistema;
    const config = "configminas";
    const tipo = "Impuesto Minas";
    const idage = props.agente.idagente;
    const nom = props.agente.nombre;
    const rif = props.agente.rif;
    const dir = props.agente.direccion;

    window.open(
      op.reportes +
        `reporte=DeudaGeneralAgente&IDAGENTE=${idage}&NOMBRE=${nom}&RIF=${rif}&DIRECCION=${dir}&CONDICION=` +
        condicion +
        "&FECHASISTEMA=" +
        fecha +
        "&CONFIG=" +
        config +
        "&TIPOIMPUESTO=" +
        tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  useEffect(() => {
    if (props.tabdeuda) {
      let deu = parseFloat(0.0);
      let inte = parseFloat(0.0);
      let reca = parseFloat(0.0);
      let mul = parseFloat(0.0);
      for (let i = 0; i < props.tabdeuda.length; i++) {
        deu = deu + parseFloat(props.tabdeuda[i].monto);
        inte = inte + parseFloat(props.tabdeuda[i].intereses);
        reca = reca + parseFloat(props.tabdeuda[i].recargo);
        mul = mul + parseFloat(props.tabdeuda[i].multa);
      }

      setDeuda(formatMoneda(deu.toString().replace(".", ","), ",", ".", 2));
      setInteres(formatMoneda(inte.toString().replace(".", ","), ",", ".", 2));
      setRecargo(formatMoneda(reca.toString().replace(".", ","), ",", ".", 2));
      setMulta(formatMoneda(mul.toString().replace(".", ","), ",", ".", 2));
      setTotDeuda(
        formatMoneda(
          (deu + inte + reca + mul).toString().replace(".", ","),
          ",",
          ".",
          2
        )
      );
      setRecords(props.tabdeuda);
    }
  }, [props.tabdeuda]);

  return (
    <div className="card">
      <div className="card-body" style={{ height: "100%" }}>
        <div className="content">
          <div className="container">
            <div className="row col-md-12" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-md-9">
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        records.map((item, index) => (
                          <TableRow
                            key={item.anio + item.mes}
                            style={{ padding: "0" }}
                          >
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "center" }}
                            >
                              {item.anio}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "cente" }}
                            >
                              {item.mes}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "left" }}
                            >
                              {item.concepto}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.monto.toString().replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.intereses.toString().replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.recargo.toString().replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
                <div className="row col-md-3 mx-auto mx-auto">
                  <div className="col-sm-6 mx-auto">
                    <button
                      onClick={imprimirDeudaGeneral}
                      className="btn btn-sm btn-info px-2 py-1 rounded-pill"
                      style={{ fontSize: "12px" }}
                    >
                      <i className="fas fa-print"> Imprimir </i>{" "}
                    </button>
                  </div>

                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-8">
                        <label htmlFor="inputRitm">Deuda: </label>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "right" }}>
                        <label htmlFor="inputRitm">{deuda}</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <label htmlFor="inputRitm">Intereses de Mora: </label>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "right" }}>
                        <label htmlFor="inputRitm">{interes}</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <label htmlFor="inputRitm">Recargo por Mora: </label>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "right" }}>
                        <label htmlFor="inputRitm">{recargo}</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <label htmlFor="inputRitm">Multa: </label>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "right" }}>
                        <label
                          htmlFor="inputRitm"
                          style={{ textAlign: "right" }}
                        >
                          {multa}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <label htmlFor="inputRitm">Total de la Deuda: </label>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "right" }}>
                        <label
                          htmlFor="inputRitm"
                          style={{ textAlign: "right" }}
                        >
                          {totDeuda}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-12"
                  style={{ textAlign: "center", marginTop: "20px" }}
                >
                  <div className="row" style={{ margin: 0 }}>
                    <div className="col-md-4">
                      <label
                        htmlFor="inputRitm"
                        style={{ fontSize: "16px", margin: 0 }}
                      >
                        {" "}
                        &nbsp;{" "}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <label
                        htmlFor="inputRitm"
                        style={{
                          fontSize: "16px",
                          margin: 0,
                          fontWeight: "bold",
                        }}
                      >
                        Crédito a Favor:{" "}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <label
                        htmlFor="inputRitm"
                        style={{
                          fontSize: "16px",
                          margin: 0,
                          textAlign: "right",
                          fontWeight: "bold",
                        }}
                      >
                        {props.credito !== null
                          ? formatMoneda(
                              props.credito.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : "0,00"}
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label
                        htmlFor="inputRitm"
                        style={{ fontSize: "16px", margin: 0 }}
                      >
                        {" "}
                        &nbsp;{" "}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaDeudaMinas;



// WEBPACK FOOTER //
// ./src/components/minas/tablaDeudaMinas.js